//测试
//const baseURL = 'http://192.168.1.102:8088/web';
//本地
//const baseURL = 'http://localhost:8081/web-war'; //群杰
//本地
//const baseURL = 'http://192.168.1.29:8080/web'; //思汗
//本地
//const baseURL = 'http://192.168.1.41:8080/web'; //泽泽
//部署
const baseURL = 'http://com.gd.gov.cn/tzgd/hdbm/web';
export default {
  baseURL,
};
